import { createSlice } from "@reduxjs/toolkit";

const initialNotice = {
  explanation: ""
};

const initialNoticesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  notice: initialNotice
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentNoticeSlice = createSlice({
  name: "studentNotices",
  initialState: initialNoticesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getSections
    sectionsFetched: (state, action) => {
      state.actionsLoading = false;
      state.sections = action.payload;
    },
    //getNoticeDetail
    noticeFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.notice = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanListState
    listStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    },
    //cleanStudentNoticesState
    studentNoticesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.sections = [];
      state.totalCount = 0;
      state.notice = initialNotice;
    }
  }
});